export const portuguese = {
  // Processing Result States
  test_completed_processing_result_states: 'Teste concluído!',
  video_upload_in_progress_processing_result_states: 'Seu vídeo ainda está sendo enviado, aguarde...',
  test_completed_processing_result_description:
    'Calculando sua nota... Pode levar alguns segundos.',
  test_success_message_processing_result_states:
    'Mandou bem! Você concluiu o teste com êxito.',
  preparing_report_processing_result_states:
    'Estou preparando seu relatório...',

  // Welcome States
  welcome_message_setup_states_welcome: 'Seja bem-vindo',
  julia_introduction_setup_states_welcome:
    'Eu sou a Julia e estarei te auxiliando no',
  fluency_test_setup_states_welcome: 'Teste de Fluência.',
  setup_message_setup_states_welcome:
    'Antes de iniciar, precisamos fazer uma rápida configuração. Vamos lá?',
  next_button_setup_states_welcome: 'Próximo',

  // Listening Test States
  check_sound_setup_states_listening_test: 'Vamos checar seu som!',
  audio_test_message_setup_states_listening_test:
    'Vou te mandar um áudio e veja se você consegue me ouvir.',
  listening_button_setup_states_listening_test: 'Estou escutando',
  not_listening_button_setup_states_listening_test: 'Não escutei',

  // Listening Test Error Container
  hmm_listening_test_error: 'Humm...',
  not_hearing_listening_test_error: 'Não está me ouvindo?',
  troubleshoot_message_listening_test_error:
    'Verifique se o fone de ouvido está com o volume baixo ou desconectado. Se o problema persistir, fale com o professor responsável.',
  try_again_listening_test_error: 'Tentar novamente',

  // Timer Tip States
  last_thing_setup_states_timer_tip: 'Ah! Última coisa...',
  timer_message_part1_setup_states_timer_tip:
    'Fique de olho no relógio! Fale no mínimo',
  twenty_seconds_setup_states_timer_tip: '20 segundos',
  timer_message_part2_setup_states_timer_tip:
    'em cada áudio. Quanto mais você falar, melhor será seu resultado.',
  start_warmup_setup_states_timer_tip: 'Iniciar aquecimento',

  // Recording Test Error States
  hmm_recording_test_error: 'Hmm...',
  microphone_not_good_recording_test_error: 'Seu microfone não parece bom.',
  audio_quality_recording_test_error: 'Qualidade do áudio:',
  microphone_settings_message_recording_test_error:
    'Verifique as configurações do seu microfone ou fale com o professor responsável.',
  try_again_recording_test_error: 'Tentar novamente',

  // Recording User Audio States
  great_recording_user_audio: 'Ótimo!',
  almost_there_recording_user_audio: 'Estamos quase lá',
  record_audio_instruction_recording_user_audio:
    'Agora grave o áudio lendo a frase abaixo:',
  record_audio_button_recording_user_audio: 'Gravar Audio',

  // Video setup
  video_check_title_video_test: 'Falta pouco!',
  video_check_subtitle_video_test: 'este é o último ajuste',
  video_check_instruction_video_test:
    'Neste teste vamos gravar seu video, vamos validar se esta tudo certo com sua câmera',
  enable_camera_button_video_test: 'Permitir acesso',
  next_button_video_test_done: 'Continuar',
  camera_disabled_video_test_error: 'A Câmera está Desabilitada!',
  camera_enable_instructions_video_test_error:
    'Na barra de endereços do seu navegador, clique no ícone ao lado do endereço do site, selecione permitir câmera e recarregue a página.',
  reload_button_video_test_error: 'Recarregar',
  video_check_terms:
    'Ao continuar, você aceita que eu video será gravado e armazenado.',

  // Word Usage Chart Components
  advanced_words_app_resultado_components_word_usage_chart:
    'palavras avançadas',

  site_demonstration_contact_app_resultado_page: 'Entre em contato',
  demonstration_result_warning:
    'Você realizou um teste demonstrativo, mais curto. Os resultados podem não refletir sua fluência real. Para ter a experiência completa, fale conosco',

  // Export Page
  complete_report_app_resultado_export_page: 'Relatório completo:',
  page_number_app_resultado_export_page: 'Página {0}/5',
  performed_by_app_resultado_export_page: 'Realizado por: {0}',
  performed_on_app_resultado_export_page: 'Realizado em: {0}',
  overall_result_app_resultado_export_page: 'Resultado Geral',
  fluency_analysis_app_resultado_export_page: 'Análise de fluidez',
  speaking_time_app_resultado_export_page: 'Tempo falando',
  seconds_label_app_resultado_export_page: 'Segundos',
  pause_count_app_resultado_export_page: 'Quantidade de pausas',
  pauses_label_app_resultado_export_page: 'Pausas',
  vocabulary_analysis_app_resultado_export_page: 'Análise de vocabulário',
  pronunciation_analysis_app_resultado_export_page: 'Análise de pronúncia',
  grammar_analysis_app_resultado_export_page: 'Análise gramatical',
  coherence_analysis_app_resultado_export_page: 'Análise de coerência',

  //Category score
  title_category_score: 'Score por Categoria',
  label_pronunciation_category_score: 'Pronúncia',
  label_fluency_category_score: 'Fluidez',
  label_grammar_category_score: 'Gramática',
  label_coherence_category_score: 'Coerência',
  label_vocabulary_category_score: 'Vocabulário',

  //Recording audio
  twenty_seconds_recording_audio:
    'Você falou por {0} segundos. Tente falar mais de 20 segundos para ter um melhor resultado.',

  //User Message
  loading_user_message: 'Carregando',

  //Microhpone permission
  click_microphone_permission: 'Clique em',
  allow_mic_microphone_permission: 'Permitir Microfone',
  message_one_microphone_permission:
    'Vamos precisar que seu microfone esteja habilitado, bastar clicar no botão',
  message_two_microphone_permission: 'Permitir Acesso ao Microfone',
  message_three_microphone_permission: 'e em seguida clicar no botão',
  message_four_microphone_permission: 'Permitir',
  message_five_microphone_permission: 'no seu navegador.',

  // Export Page
  grammar_vocabulary_analysis_app_resultado_export_page:
    'Análise gramatical e de vocabulário',
  conversation_analysis_app_resultado_export_page: 'Análise da conversa',
  advanced_words_usage_app_resultado_export_page:
    'Uso de palavras de níveis avançados',
  cefr_reference_app_resultado_export_page:
    'Quadro comum europeu de referência para línguas',
  total_pause_duration_app_resultado_export_page: 'Duração total das pausas',
  longest_phrase_without_hesitation_app_resultado_export_page:
    'Tamanho da maior frase sem hesitar',

  // Resultado Page
  performed_by_app_resultado_page: 'Realizado por: {0}',
  performed_on_app_resultado_page: 'Realizado em: {0}',
  overall_result_app_resultado_page: 'Resultado Geral',
  fluency_level_app_resultado_page: 'Nível de inglês fluente',
  oral_expression_level_app_resultado_page: 'Nível de Expressão Oral',
  conversation_analysis_app_resultado_page: 'Análise da conversa',
  conversation_analysis_grammar_errors_app_resultado_page: 'Erros gramaticais',
  conversation_analysis_words_app_resultado_page: 'Palavras',
  conversation_analysis_unique_words_app_resultado_page: 'Palavras únicas',
  fluency_analysis_app_resultado_page: 'Análise de fluidez',
  grammar_vocabulary_analysis_app_resultado_page:
    'Análise gramatical e de vocabulário',
  terms_used_section_app_resultado_page:
    'Termos usados nas principais gramáticas',
  advanced_words_usage_app_resultado_page:
    'Uso de palavras de níveis avançados',
  conversation_recording_app_resultado_page: 'Gravação da conversa',
  view_errors_only_app_resultado_page: 'Ver somente erros',
  view_full_conversation_app_resultado_page: 'Ver conversa completa',
  hidden_audio_single_app_resultado_page: 'audio oculto',
  hidden_audio_plural_app_resultado_page: 'audios ocultos',

  // Onboarding Modal
  step_number_onboarding_modal: 'Etapa {0}',
  verify_data_onboarding_modal: 'Verificar dados',
  know_you_better_onboarding_modal: 'Queremos te conhecer mais',
  data_verification_onboarding_modal: 'Verificação de dados',
  about_student_onboarding_modal: 'Sobre o aluno',
  before_start_verification_onboarding_modal:
    'Antes de iniciar, precisamos verificar alguns dados',
  student_data_onboarding_modal: 'Dados do aluno',
  student_name_onboarding_modal: 'Nome do aluno',
  birth_date_onboarding_modal: 'Data de Nascimento',
  incorrect_data_onboarding_modal: 'Dados incorretos',
  confirm_data_onboarding_modal: 'Confirmar Dados',
  questionnaire_completed_onboarding_modal: 'Questionário concluído!',
  thanks_information_onboarding_modal:
    'Obrigado pelas informações. Vamos iniciar o teste?',
  complete_and_go_to_test_onboarding_modal: 'Concluir e ir para o teste',
  sending_information_onboarding_modal: 'Enviando informações...',
  incorrect_registration_onboarding_modal: 'Cadastro incorreto',
  cannot_continue_test_onboarding_modal:
    'Não será possível continuar com o teste no momento. Fale com o professor responsável.',
  understood_onboarding_modal: 'Entendido',

  // Analysis Card
  score_detail_analysis_card: 'Detalhamento da nota',

  // Fluency Card
  speech_speed_fluency_card: 'Velocidade de fala',
  speech_speed_description_fluency_card:
    'Velocidade de fala incluindo pausas e tempo em silêncio',
  articulation_speed_fluency_card: 'Velocidade de articulação',
  articulation_speed_description_fluency_card:
    'Velocidade de fala desconsiderando o tempo em silêncio e pausas.',

  // Test Start Message
  test_start_test_start_message: 'Início do teste',
  great_job_test_start_message: 'Mandou bem!',
  now_fluency_test_test_start_message: 'Agora vamos para o teste de fluência.',
  test_start_complete_message_test_start_message_well_done: 'Mandou bem!',
  test_start_complete_message_test_start_message_start_over:
    'Agora vamos para o',
  test_start_complete_message_test_start_message_fluency_test:
    'teste de fluência.',
  remember_speak_maximum_test_start_message:
    'Lembre-se de falar o máximo que conseguir! Aqui é momento de dar show!',

  // Microphone Permission Error
  microphone_disabled_microphone_permission_error:
    'O Microfone está Desabilitado!',
  step_one_microphone_permission_error:
    '1. Na barra de endereços do seu navegador, clique no ícone ao lado do endereço do site;',
  step_two_microphone_permission_error:
    '2. Em seguida, selecione Permitir o microfone;',
  step_three_microphone_permission_error:
    '3. Recarregue esta página para tentar novamente.',
  reload_microphone_permission_error: 'Recarregar',

  // Silence Time Chart
  speaking_time_silence_time_chart: 'Tempo falando',

  // Login State
  app_name_login: 'FluencyFlow',
  simple_engaging_fluency_test_login: 'Teste de fluência simples e envolvente.',
  we_make_it_easier_login: 'Nós tornamos mais fácil.',
  access_code_label_login_form: 'Código de acesso',
  unauthorized_error_login_form: 'Código de acesso não autorizado.',
  test_in_progress_error_login_form: 'O teste está em progresso ou finalizado.',

  // Terms Used Table
  grammar_terms_used_table: 'Gramática',
  quantity_terms_used_table: 'Qtd. Termos',
  terms_terms_used_table: 'Termos',

  // Analysis Card
  example_label_analysis_card: 'Exemplo:',
  fluency_title_analysis_card: 'Fluidez',
  fluency_title_mobile_analysis_card: 'Fluidez',

  // Descriptive Feedback
  descriptive_feedback_title: 'Feedback descritivo',

  // Speaking Metrics
  speaking_time_speaking_metrics: 'Tempo falando',
  seconds_label_speaking_metrics: 'Segundos',
  pause_count_speaking_metrics: 'Quantidade de pausas',
  pauses_label_speaking_metrics: 'Pausas',
  pauses_ideal_label_speaking_metrics: 'Ideal',
  total_pause_duration_speaking_metrics: 'Duração total das pausas',
  longest_phrase_without_hesitation_speaking_metrics:
    'Tamanho da maior frase sem hesitar',
  until_speaking_metrics: 'até',
  more_speaking_metrics: 'mais',

  // Analysis Types
  grammar_analysis_type: 'Gramática',
  vocabulary_analysis_type: 'Vocabulário',
  coherence_analysis_type: 'Coerência',

  // Conversation Analysis Labels
  grammar_errors_conversation_analysis: 'Erros gramaticais',
  sentences_conversation_analysis: 'Frases',
  words_conversation_analysis: 'Palavras',
  average_words_per_sentence_conversation_analysis:
    'Média de palavras por frase',
  unique_words_conversation_analysis: 'Palavras únicas',
  average_unique_words_per_sentence_conversation_analysis:
    'Média de palavras únicas por frase',
  total_syllables_conversation_analysis: 'Total de sílabas',
  words_with_two_or_more_syllables_conversation_analysis:
    'Palavras com mais de duas sílabas',
  long_pauses_plural_label_conversation_analysis: 'Pausas longas',
  long_pause_label_conversation_analysis: 'Pausa longa',
  errors_plural_label_conversation_analysis: 'Erros',
  error_label_conversation_analysis: 'Erro',

  // Ready to Icebreak State
  lets_warm_up_ready_to_icebreak: 'Vamos',
  warm_up_ready_to_icebreak: 'Aquecer!',
  ready_to_start_warmup_ready_to_icebreak:
    'Agora estamos prontos para iniciar o',
  warmup_ready_to_icebreak: 'aquecimento.',
  warmup_description_ready_to_icebreak:
    'Ele será baseado em uma conversa. Vou te fazendo perguntas e você me responde.',
  next_button_ready_to_icebreak: 'Próximo',

  // Icebreak Start Message
  warmup_start_icebreak_start_message: 'Início do aquecimento',

  // Recording Test Done State
  wonderful_recording_test_done: 'Maravilha!',
  hearing_you_recording_test_done: 'Estou te ouvindo',
  settings_completed_recording_test_done:
    'Configurações finalizadas! Tudo está funcionando para podermos avançar para a próxima etapa.',
  next_button_recording_test_done: 'Próximo',

  // Fluency Chart
  slow_fluency_chart: 'Lento',
  fast_fluency_chart: 'Rápido',

  // Analysis Card Metrics Details
  // Grammar Metrics
  length_analysis_card: 'Comprimento',
  length_title_analysis_card: 'Sobre o Comprimento',
  length_about_analysis_card:
    'Esta métrica fornece informações sobre o quão longa é a mensagem ou resposta reconhecida. A maneira como as frases são conectadas influencia na nota.',
  length_bad_example_analysis_card:
    'The sun shines brightly. Flowers are beautiful.',
  length_good_example_analysis_card:
    'The sun shines brightly and colorful flowers are beautiful.',

  grammatical_accuracy_analysis_card: 'Precisão Gramatical',
  grammatical_accuracy_title_analysis_card: 'Sobre a Precisão Gramatical',
  grammatical_accuracy_about_analysis_card:
    'Esta métrica analisa a correção e precisão do uso da gramática, incluindo aspectos como a utilização correta dos tempos verbais, concordância verbal e a adequada ordem das palavras. A nota é influenciada também pela conexão adequada entre palavras e frases.',
  grammatical_accuracy_bad_example_analysis_card:
    'Hi, my name are Anna. I have 20 years old.',
  grammatical_accuracy_good_example_analysis_card:
    'Hi, my name is Anna and I`m 20 years old.',

  grammatical_range_analysis_card: 'Amplitude Gramatical',
  grammatical_range_title_analysis_card: 'Sobre a Amplitude Gramatical',
  grammatical_range_about_analysis_card:
    'Esta métrica avalia o nível de diversidade nas estruturas sintáticas presentes na mensagem ou resposta reconhecida, considerando fatores como a variedade de verbos, adjetivos, modificadores adverbiais, entre outros.',
  grammatical_range_bad_example_analysis_card:
    "I'm Anna. I'm Brazilian. I'm 20 years old.",
  grammatical_range_good_example_analysis_card:
    "My name is Anna. I'm a 20-year-old girl from Brazil.",

  // Vocabulary Metrics
  lexical_range_analysis_card: 'Amplitude Lexical',
  lexical_range_title_analysis_card: 'Sobre a Amplitude Lexical',
  lexical_range_about_analysis_card:
    'Esta métrica avalia a variedade de palavras usadas e o grau de uso de vocabulário avançado e menos comum. Tem a ver com a escolha cuidadosa de palavras apropriadas, as quais oferecem detalhamento e clareza na transmissão da mensagem.',
  lexical_range_bad_example_analysis_card: 'It was a good day. I saw birds.',
  lexical_range_good_example_analysis_card:
    "The weather was just perfect and I couldn't help but notice a variety of birds...",

  collocation_commonality_analysis_card: 'Comunalidade de Colocações',
  collocation_commonality_title_analysis_card:
    'Sobre a Comunalidade de Colocações',
  collocation_commonality_about_analysis_card:
    'Esta métrica avalia o uso de combinações de palavras, como colocações, frases preposicionais e preposições dependentes. O objetivo é avaliar o quão o discurso se alinha com os padrões linguísticos coloquiais e naturais.',
  collocation_commonality_bad_example_analysis_card:
    'I have a brother. I like him.',
  collocation_commonality_good_example_analysis_card:
    'I have a brother and we get along really well.',

  natural_phrases_analysis_card: 'Frases Naturais',
  natural_phrases_title_analysis_card: 'Sobre Frases Naturais',
  natural_phrases_about_analysis_card:
    'Esta métrica avalia o quão natural, coloquial e culturalmente apropriada é a linguagem utilizada.',
  natural_phrases_bad_example_analysis_card:
    'I am an engineer. I`m responsible for...',
  natural_phrases_good_example_analysis_card:
    'In my role as an engineer I`m in charge of...',

  // Coherence Metrics
  content_words_analysis_card: 'Palavras de conteúdo',
  content_words_title_analysis_card: 'Sobre Palavras de conteúdo',
  content_words_about_analysis_card:
    'Esta métrica avalia a proporção de palavras únicas ou palavras de conteúdo, que são aquelas que contribuem diretamente para o significado ou conteúdo, em oposição a palavras que desempenham principalmente funções gramaticais ou de ligação.',
  content_words_bad_example_analysis_card: ' I am a teacher and I work a lot',
  content_words_good_example_analysis_card:
    'I am a passionate and experienced teacher who works hard in a renowned shcool',

  connectors_analysis_card: 'Conectores',
  connectors_title_analysis_card: 'Sobre os Conectores',
  connectors_about_analysis_card:
    'São palavras ou expressões que estabelecem relações lógicas e coesão entre as partes de um discurso ou texto. Esses conectivos ajudam a conectar ideias, indicar contraste, adição, conclusão, negação, entre outras relações.',
  connectors_bad_example_analysis_card:
    'Yesterday was a nice day. We went to the beach. The sun was hot.',
  connectors_good_example_analysis_card:
    'Yesterday was a nice day because the sun was hot. So, we went to the beach.',

  pronoun_density_analysis_card: 'Densidade de Pronomes',
  pronoun_density_title_analysis_card: 'Sobre a Densidade de Pronomes',
  pronoun_density_about_analysis_card:
    'Esta métrica avalia o grau de uso de pronomes na resposta. Uma alta pronoun density pode indicar uma fala mais concisa e dinâmica pois com uso de pronomes evita-se a repetição excessiva de substantivos e contribui para a fluidez e clareza do texto.',
  pronoun_density_bad_example_analysis_card:
    'It`s my dad`s birthday. I bought a gift for my father.',
  pronoun_density_good_example_analysis_card:
    'It`s my father`s birthday so I bought him a gift.',

  adverb_diversity_analysis_card: 'Diversidade de Advérbios',
  adverb_diversity_title_analysis_card: 'Sobre a Diversidade de Advérbios',
  adverb_diversity_about_analysis_card:
    'Esta métrica refere-se à variedade de advérbios utilizados na resposta. Uma alta adverb density pode indicar uma linguagem mais descritiva e detalhada.',
  adverb_diversity_bad_example_analysis_card: 'I bought a gift for my father.',
  adverb_diversity_good_example_analysis_card:
    'Yesterday, I suddenly remembered it was my father`s birthday so I quickly bought him a gift.',

  verb_diversity_analysis_card: 'Diversidade de Verbos',
  verb_diversity_title_analysis_card: 'Sobre Diversidade de Verbos',
  verb_diversity_about_analysis_card:
    'Esta métrica avalia o grau e a variedade de verbos na resposta. Analisar a verb density em um texto pode fornecer insights sobre o dinamismo, a ação e a fluidez do discurso.',
  verb_diversity_bad_example_analysis_card:
    'I like pasta. I like food. I like chocolate.',
  verb_diversity_good_example_analysis_card:
    'I like pasta. I love food. I enjoy hanging out with friends.',

  // CEFR Levels
  cefr_a1_title: 'Iniciante',
  cefr_a1_description:
    'Consegue compreender e usar expressões familiares e cotidianas, além de frases simples relacionadas a situações concretas. É capaz de se apresentar, responder perguntas básicas sobre informações pessoais e interagir de forma limitada, desde que o interlocutor fale devagar, com clareza e esteja disposto a ajudar. Lida com vocabulário restrito a necessidades imediatas.',

  cefr_a2_title: 'Básico',
  cefr_a2_description:
    'Consegue se comunicar em tarefas simples e rotineiras que exigem troca direta de informações sobre assuntos conhecidos. É capaz de descrever com frases encadeadas aspectos do seu cotidiano, como família, ambiente de trabalho ou escola, preferências e necessidades básicas. Mostra maior autonomia em interações previsíveis, embora ainda com vocabulário limitado e construções simples.',

  cefr_b1_title: 'Intermediário',
  cefr_b1_description:
    'Consegue compreender os pontos principais de informações claras em linguagem padrão sobre temas familiares, como trabalho, lazer ou escola. É capaz de lidar com a maioria das situações que podem surgir em viagens a países de língua inglesa e consegue produzir textos simples, conectados e coerentes sobre assuntos conhecidos. Consegue expressar opiniões, descrever experiências e justificar brevemente planos e decisões.',

  cefr_b2_title: 'Intermediário Avançado',
  cefr_b2_description:
    'Consegue compreender ideias principais de textos mais complexos, incluindo discussões técnicas na sua área de especialidade. Interage com fluência e espontaneidade suficientes para manter uma conversa natural com falantes nativos. Consegue argumentar com clareza, desenvolver pontos de vista, apresentar vantagens e desvantagens e produzir textos bem estruturados e detalhados sobre uma ampla variedade de temas.',

  cefr_c1_title: 'Avançado',
  cefr_c1_description:
    'Consegue compreender uma vasta gama de textos longos e exigentes, identificando significados implícitos, uso figurado e estruturas complexas. Se expressa de forma fluente, espontânea e eficaz, com alto grau de precisão lexical e domínio gramatical. É capaz de adaptar sua linguagem ao contexto e ao interlocutor, mostrando flexibilidade comunicativa em situações acadêmicas, profissionais e sociais complexas.',

  cefr_c2_title: 'Proficiência',
  cefr_c2_description:
    'Consegue compreender com facilidade praticamente tudo o que ouve ou lê, incluindo textos abstratos, técnicos ou literários. É capaz de resumir informações de diversas fontes, reconstruir argumentos e apresentar conteúdos de forma coerente. Se expressa com precisão, naturalidade e espontaneidade, mesmo em situações altamente complexas ou de forte carga emocional, demonstrando pleno domínio da língua.',

  // New keys for buttons
  incorrect_data_button_setup_states_welcome_onboarding_modal:
    'Dados incorretos',
  confirm_data_button_setup_states_welcome_onboarding_modal: 'Confirmar Dados',
  complete_and_go_to_test_button_setup_states_welcome_onboarding_modal:
    'Concluir e ir para o teste',
  understood_button_setup_states_welcome_onboarding_modal: 'Entendido',
  reload_button_setup_states_microphone_permission_error: 'Recarregar',
  allow_microphone_access_button_setup_states_microphone_permission:
    'Permitir acesso ao microfone',
  access_button_login_form: 'Acessar',
  send_button_recording_audio: 'Send',
  got_it_button_recording_audio: 'GOT IT',
  repeat_slower_button_testing_didnt_understand: 'Repetir mais devagar',
  next_question_button_testing_didnt_understand: 'Próxima pergunta',
  didnt_understand_icebreak_testing_didnt_understand: 'Não entendi',
  didnt_understand_test_testing_didnt_understand: "Didn't understand",
  close_modal_button: 'Fechar',
  confirm_button_setup_about_student_form: 'Confirmar Dados',
  confirm_topic_button_topic_selector: 'Confirmar',

  steps_introduction: 'Introdução',
  steps_warmup: 'Aquecimento',
  steps_test: 'Teste',
  steps_result: 'Resultado',

  title_message_topic_selector: 'Selecione dois assuntos:',

  result_nav_bar_result: 'Resultado',
  result_nav_bar_fluency_analysis: 'Análise de Fluência',
  result_nav_bar_grammar_analysis: 'Análise Gramatical',
  result_nav_bar_conversation_recording: 'Gravação da Conversa',

  // Demo Access Expired
  title_demo_access_expired: 'Seu acesso expirou',
  message_demo_access_expired:
    'Não foi possível retomar o seu teste. Entre em contato com o aplicador do teste para receber um novo link de acesso.'
}
